import {useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {routePaths} from "../../../../../shared/utils/constants/routePaths";
import * as actions from "../../../../../store";
import {Button, Grid, Typography} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {Skeleton} from "@material-ui/lab";
import {getRandomNumber} from "../../../../../shared/utils/utils";
import {formatMissingData} from "../../../../../shared/utils/formatDataUtils";
import BoxWithImage from "../../../../../shared/components/box-with-image/BoxWithImage";
import calendarIcon from "../../../../../assets/images/icon-big-calendar-88-px.svg";
import OrdiniConsipTabs from "./ordini-consip-tabs/OrdiniConsipTabs";

const OrdiniConsipDetails = () => {

    const {consipId} = useParams()
    const history = useHistory()
    const dispatch = useDispatch()

    const [selectedTab, setSelectedTab] = useState(0)

    const ordiniConsip = useSelector(state => state.ordiniConsipReducer.ordiniConsipDetails.data);
    const loading = useSelector(state => state.ordiniConsipReducer.ordiniConsipDetails.loading);
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)
    const firstRender = useRef(true)

    const handleBackClick = () => {
        history.push(routePaths.ORDINI_CONSIP_TM9);
    }

    useEffect(() => {
        dispatch(actions.getOrdiniConsipDetails(integrationId, consipId))
        dispatch(actions.getOrdiniConsipOfferta(integrationId, consipId))
    }, [dispatch, consipId, integrationId])

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false
        } else {
            history.replace(routePaths.ORDINI_CONSIP_TM9)
        }
    }, [history, integrationId])

    return (
        <>
            <Grid container
                  spacing={3}>
                <Grid item
                      xs={12}>
                    <Button color="primary"
                            onClick={handleBackClick}
                            variant="text"
                            startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                        Indietro
                    </Button>
                </Grid>

                <Grid item
                      xs={12}>
                    <Typography variant="subtitle1">
                        {loading ?
                            <Skeleton animation='wave'
                                      width={`${getRandomNumber(10, 30)}%`}/> :
                            formatMissingData(ordiniConsip.nome)}
                    </Typography>
                </Grid>

                <Grid item container
                      spacing={3}
                      xs={12}>
                    <Grid item
                          xs={12} sm={8} md={4}>
                        <BoxWithImage
                            title={"Data sottoscrizione"}
                            loading={false}
                            content={formatMissingData(ordiniConsip.dataSottoscrizioneCaption)}
                            image={calendarIcon}/>
                    </Grid>
                </Grid>

                <Grid item
                      xs={12}>
                    <OrdiniConsipTabs
                        selectedTab={selectedTab}
                        setSelectedTab={setSelectedTab}/>
                </Grid>
            </Grid>
        </>
    );
}

export default OrdiniConsipDetails;